import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Button } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { Input, Label } from "reactstrap";

export const CustomerSelector = ({
    t,
    isHospitalConnected,
    customerType,
    onCustomerTypeChange,
    walkingCustomerName,
    onWalkingNameChange,
    customerError,
    patientSelectRef,
    loadPatients,
    onPatientChange,
    disableScrollProps,
    onSearchBySaleNumber,
    saleSearchMode,
    onSaleSearchModeChange,
    saleNumberInputRef,
    saleNumberValue,
    setSaleNumberValue
}) => {

    const handleSearchClick = () => {
        if (saleNumberValue.trim()) {
            onSearchBySaleNumber(saleNumberValue);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
    };

    const handleWalkingSelect = () => {
        onCustomerTypeChange("walking");
        onSaleSearchModeChange(true);
        setSaleNumberValue("");
    };

    const handleExistingSelect = () => {
        onCustomerTypeChange("inpatient");
        onSaleSearchModeChange(false);
        setSaleNumberValue("");
    };

    const handleHospitalSelect = () => {
        onCustomerTypeChange("hospital_patient");
        onSaleSearchModeChange(false);
        setSaleNumberValue("");
    };

    return (
        <Row className="mb-1 g-2 align-items-center">
            <Col sm="auto" md="3" lg="auto">
                <Form.Label className="mb-0 pe-2">{t("Customer")}:</Form.Label>
            </Col>
            <Col sm="auto" md="3" lg="auto">
                <div className="radio radio-primary">
                    <Input
                        id="return-customer-walking"
                        type="radio"
                        name="returnCustomerType"
                        value="walking"
                        checked={customerType === "walking"}
                        onChange={handleWalkingSelect}
                    />
                    <Label for="return-customer-walking" className="mb-0 pe-2">
                        {t("Walk-in")}
                    </Label>
                </div>
            </Col>
            <Col sm="auto" md="3" lg="auto">
                <div className="radio radio-primary">
                    <Input
                        id="return-customer-inpatient"
                        type="radio"
                        name="returnCustomerType"
                        value="inpatient"
                        checked={customerType === "inpatient"}
                        onChange={handleExistingSelect}
                    />
                    <Label for="return-customer-inpatient" className="mb-0 pe-2">
                        {t("Existing")}
                    </Label>
                </div>
            </Col>
            {isHospitalConnected && (
                <Col sm="auto" md="3" lg="auto">
                    <div className="radio radio-primary">
                        <Input
                            id="return-customer-hospital_patient"
                            type="radio"
                            name="returnCustomerType"
                            value="hospital_patient"
                            checked={customerType === "hospital_patient"}
                            onChange={handleHospitalSelect}
                        />
                        <Label for="return-customer-hospital_patient" className="mb-0 pe-2">
                            {t("Clinic")}
                        </Label>
                    </div>
                </Col>
            )}
            <Col md="9" lg="6">
                <div className="async-select-container" style={{ position: "relative" }}>
                    {saleSearchMode || customerType === "walking" ? (
                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            <Form.Control
                                ref={saleNumberInputRef}
                                type="text"
                                value={saleNumberValue}
                                onChange={(e) => setSaleNumberValue(e.target.value)}
                                placeholder={t("Enter sale/invoice number...")}
                                className="search-product"
                                onKeyDown={handleKeyDown}
                                {...disableScrollProps}
                            />
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={handleSearchClick}
                                style={{ whiteSpace: "nowrap", minWidth: "80px" }}
                            >
                                {t("Search")}
                            </Button>
                        </div>
                    ) : (
                        <AsyncSelect
                            ref={patientSelectRef}
                            cacheOptions
                            defaultOptions
                            loadOptions={loadPatients}
                            onChange={onPatientChange}
                            placeholder={customerType === "inpatient" ? t("Search customer by name or phone...") : t("Search patient by name or phone...")}
                            noOptionsMessage={({ inputValue }) =>
                                inputValue.length < 3 ? t("Type at least 3 characters") : t("No patients found")
                            }
                            isClearable
                            menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
                            menuShouldScrollIntoView
                        />
                    )}
                </div>
            </Col>
        </Row>
    );
};

export default CustomerSelector;